<nav class="navbar navbar-dark sticky-top">
	<div class="container-fluid">
		<div class="navbar-brand">
			<input
				type="text"
				class="form-control"
				id="transportTemplatesName"
				name="name"
				[(ngModel)]="data.name"
				placeholder="Nazwa szablonu"
				(ngModelChange)="nameUpdated()"
			/>
		</div>
		<div class="d-flex">
			<div *ngIf="service.vehicleSelected" class="vehicleBox">
				<div class="btn btn-outline-light me-4">
					<i class="fas fa-bus"></i>
					{{ service.vehicleSelected?.name }}
					<i class="fas fa-users"></i>
					{{
						service.vehicleSelected?.seats -
							service.vehicleSelected?.occupied -
							service.vehicleSelected?.crew
					}}
				</div>
				<div class="vehicleList">
					<div
						class="btn btn-outline-light"
						*ngFor="let vehiclesItem of service.vehicles"
						(click)="service.selectVehicle(vehiclesItem)"
					>
						<i class="fas fa-bus"></i>
						{{ vehiclesItem?.name }}
						<i class="fas fa-users"></i>
						{{ vehiclesItem?.seats - vehiclesItem?.occupied - vehiclesItem?.crew }}
					</div>
				</div>
			</div>
			<button class="btn btn-primary me-4" (click)="mapComponent.vehiclesToggle()">
				<i class="fas fa-bus"></i> Pojazdy
			</button>
			<button class="btn btn-warning" (click)="submit()">
				Następny etap
				<i class="fas fa-arrow-right"></i>
			</button>
		</div>
	</div>
</nav>

<app-map [(data)]="data" [(map)]="map"></app-map>
